<script setup lang="ts">
import { ref } from 'vue'

import { Button, Popover } from '@collector/shared-ui'

import { QueueViewPopoverButtonProps } from '../interfaces/QueueViewPopoverButtonProps'
import { setShowQueueCallback } from '../utils'
import QueueView from './QueueView/QueueView.vue'

const props = defineProps<QueueViewPopoverButtonProps>()

// state
const incidentsCount = ref<number | null>(null)
const shouldShowError = ref(false)
const isPopoverOpen = ref(false)

// init
props.eventIncidentsQueue.subscribeOnChange(
  ({ queue, errorQueueIncidents }) => {
    incidentsCount.value = queue.length
    shouldShowError.value = !!errorQueueIncidents.length
  },
)

setShowQueueCallback(() => (isPopoverOpen.value = true))
</script>

<template>
  <Popover
    v-model="isPopoverOpen"
    :content="{
      class: '@sm:-mr-10',
    }"
    :trigger="{
      asChild: true,
    }"
    :withCloseIcon="false"
  >
    <template #trigger>
      <Button
        :class="{
          'bg-neutral-light-0! border-neutral-light-0!': isPopoverOpen,
          'error-pulse': shouldShowError,
          [`${$attrs.class}`]: $attrs.class,
        }"
        :size
        :icon
        :iconSize
        :square
      >
        <slot />
        <div v-if="incidentsCount !== null">
          <span>(</span>
          <span class="inline-block min-w-3">{{ incidentsCount }}</span>
          <span>)</span>
        </div>
      </Button>
    </template>
    <template #content>
      <QueueView
        :eventIncidentsQueue
        :isIncidentImportant
        :getIncident
        :homeParticipant
        :awayParticipant
        :incidentIdToSportIncidentMap
      />
    </template>
  </Popover>
</template>

<style scoped>
@import '../style.css';

@keyframes error-pulse-animation {
  50% {
    background-color: var(--color-error-5);
    border-color: var(--color-error-5);
    color: var(--color-neutral-light-10);
  }
}

.error-pulse {
  animation: error-pulse-animation 3s infinite;
}
</style>
